import backendUrl from './backendUrl';

const axios = require('axios');

const hit = (gameId) => {
    axios.post(backendUrl('/hit'), {
        game_id: `${gameId}`,
    }).then((response) => {
        console.log(`Hit OK for ${gameId}.`);
    }, (error) => {
        console.log(`Hit Error for ${gameId}.`);
    });
}

export default hit
